module.exports = __webpack_public_path__ + "img/preview.07ffbfdb.svg";